import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router/router.js'
Vue.use(Vuex)

import {
  SystemRequestGet as $_get
} from '@/request/http.js'

// 引入其他模块数据
import TestModule from './test';


const store = new Vuex.Store({
  state: { // 全局变量定义处
    subject: 'czwl', // 当前科目
    nav: {}, // 导航栏信息
    user: {}, // 存储用户信息
    hasLogin: false, // 用户是否登陆
    authToken: '' // token
  },
  mutations: { // 全局方法定义处
    SET_TOKEN(state, token) {
      state.userToken = token;
      sessionStorage.setItem("w_system_g_authToken", token);
      Vue.prototype.authToken = token;
    },
    /**
     * 设置 当前科目
     */
    updateSubject(state, sub) {
      state.subject = sub;
    },
    /**
     * 设置导航栏信息
     */
    setNavInfo(state, data) {
      state.nav = data || {};
    },
    /**
     * 设置个人信息
     */
    setUserInfo(state, data) {
      state.user = data || {};
    }
  },
  actions: {
    /**
     * 获取导航栏信息
     */
    getNav({
      commit,
      state
    }) {
      $_get('common_nav', {
          sub: state.subject
        })
        .then(res => {
          if (Number(res.code) === 0) {
            commit('setNavInfo', res.nav);
          }
        });
    },
    /**
     * 获取个人信息
     */
    getUsermsg({
      commit
    }) {
      $_get('user_getmsg')
        .then(res => {
          if (Number(res.code) === 0) {
            commit('setUserInfo', res.user);
          } else {
            commit('setUserInfo', {});
          }
        });
    },
    /**
     * 退出登录
     */
    logout({
      commit
    }) {
      window._method.setCookie('logout_from', window.location.href, 1, false);
      window.location.href = window.API_NAME + "/user_logout/";
      setTimeout(function () {
        commit('setUserInfo', {});
        window.location.reload();
      }, 1000);
    }
  },
  modules: {
    // 组卷相关
    'test': TestModule
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js